import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import { postAuth, type PostAuthResponse } from '@services/AuthService';

export type UsePostAuthParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostAuthResponse,
    unknown,
    string,
    never,
    PostAuthResponse
  >;
};

export const postAuthMutationKey = 'post-auth';

export const usePostAuth = ({ mutationOptions }: UsePostAuthParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostAuthResponse,
    unknown,
    string,
    never
  >(postAuthMutationKey, () => postAuth(), mutationOptions);

  return {
    trigger,
    ...swrResponse,
  };
};
